import React, { useState } from "react";
import { T } from "../theme";
import { Btn, Card, TapeIcon } from "../ui";

export default function CartScreen({ cart, onUpdateQuantity, onRemove, onBack }) {
  const [busyLineId, setBusyLineId] = useState(null);

  const changeQty = async (lineId, qty) => {
    setBusyLineId(lineId);
    try {
      if (qty <= 0) await onRemove(lineId);
      else await onUpdateQuantity(lineId, qty);
    } finally {
      setBusyLineId(null);
    }
  };

  const checkout = () => {
    if (cart?.checkoutUrl) window.open(cart.checkoutUrl, "_blank", "noopener,noreferrer");
  };

  if (!cart || cart.lines.length === 0) {
    return (
      <div>
        <Card style={{ textAlign: "center", padding: 32 }}>
          <div style={{ fontSize: 13, color: T.muted }}>Your cart is empty.</div>
        </Card>
        <Btn variant="outline" onClick={onBack} style={{ width: "100%" }}>← Back to Shop</Btn>
      </div>
    );
  }

  return (
    <div>
      {cart.lines.map((line) => (
        <Card key={line.lineId} style={{ display: "flex", alignItems: "center", gap: 12 }}>
          {line.imageUrl ? (
            <img src={line.imageUrl} alt={line.productTitle} style={{ width: 48, height: 48, objectFit: "cover", borderRadius: 8 }} />
          ) : (
            <TapeIcon size={44} />
          )}
          <div style={{ flex: 1, minWidth: 0 }}>
            <div style={{ fontSize: 13, fontWeight: "bold", color: T.text }}>{line.productTitle}</div>
            {line.variantTitle !== "Default Title" && <div style={{ fontSize: 11, color: T.muted }}>{line.variantTitle}</div>}
            <div style={{ fontSize: 12, color: T.value, fontWeight: "bold", marginTop: 2 }}>${Number(line.price).toFixed(2)}</div>
          </div>
          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <button disabled={busyLineId === line.lineId} onClick={() => changeQty(line.lineId, line.quantity - 1)} style={{ width: 24, height: 24, borderRadius: 12, border: `1px solid ${T.border}`, background: T.statBg, color: T.text, cursor: "pointer" }}>−</button>
            <span style={{ fontSize: 13, minWidth: 16, textAlign: "center" }}>{line.quantity}</span>
            <button disabled={busyLineId === line.lineId} onClick={() => changeQty(line.lineId, line.quantity + 1)} style={{ width: 24, height: 24, borderRadius: 12, border: `1px solid ${T.border}`, background: T.statBg, color: T.text, cursor: "pointer" }}>+</button>
          </div>
        </Card>
      ))}

      <Card>
        <div style={{ display: "flex", justifyContent: "space-between", fontSize: 13, color: T.muted, marginBottom: 4 }}>
          <span>Subtotal</span>
          <span>${Number(cart.subtotal).toFixed(2)}</span>
        </div>
        <div style={{ display: "flex", justifyContent: "space-between", fontSize: 15, fontWeight: "bold", color: T.text }}>
          <span>Total</span>
          <span>${Number(cart.total).toFixed(2)} {cart.currencyCode}</span>
        </div>
        <div style={{ fontSize: 9, color: T.muted, marginTop: 8 }}>Checkout, shipping, and payment are handled securely by Shopify.</div>
      </Card>

      <div style={{ display: "flex", gap: 10, marginTop: 6 }}>
        <Btn variant="outline" onClick={onBack} style={{ flex: 1 }}>← Continue Shopping</Btn>
        <Btn variant="gold" onClick={checkout} style={{ flex: 2 }}>Checkout</Btn>
      </div>
      <div style={{ height: 20 }} />
    </div>
  );
}
